module.exports = __webpack_public_path__ + "static/media/ios-call.58e002dd.svg";